import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { TablePaginationActions } from '../../../components/Pagination/TablePaginationActions';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Link, useNavigate } from 'react-router-dom';
import BasicModal from '../../../components/Modal/BasicModal';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EventIcon from '@mui/icons-material/DeviceHub';
import { Box, Grid } from '@mui/material';
import { MENU_OPEN } from 'store/actions';
import { changeStatusEvent, deleteEvent, getEvents, searchEvents } from 'services/event';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
import FilterIcon from '@mui/icons-material/FilterAlt';
import ModalFilter from 'components/Modal/ModalFilter';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AnimateButton from 'ui-component/extended/AnimateButton';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Button from '@mui/material/Button';
import ptBR from 'date-fns/locale/pt-BR';
import debounce from 'lodash.debounce';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#015641',
        color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));

export default function GridEvent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const page = useSelector((state) => state.event.page);
    const rowsPerPage = useSelector((state) => state.event.rowsPerPage);
    const dateEvent = useSelector((state) => state.event.dateEvent);
    const valueDateEvent = useSelector((state) => state.event.valueDateEvent);
    const [events, setEvents] = React.useState([]);
    const [success, setSuccess] = React.useState('');
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [error, setError] = React.useState('');
    const [idDestroyEvent, setIdDestroyEvent] = React.useState('');
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalFilter, setOpenModalFilter] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState('');

    const withLink = (to, children) => <Link to={to}>{children}</Link>;
    const actions = [
        { icon: withLink('/novo_evento', <EventIcon sx={{ color: '#015641', marginTop: 1 }} />), name: 'Novo Evento' },
        { icon: withLink('#/', <FilterIcon sx={{ color: '#015641', marginTop: 1 }} />), name: 'Filtros', operation: 'filtros' }
    ];

    const handleCloseModalFilter = () => setOpenModalFilter(false);

    const handleOpenDestroy = (idDestroy) => {
        setIdDestroyEvent(idDestroy);
        setOpenModal(true);
    };

    const handleCloseModal = () => setOpenModal(false);

    const handleChangePage = (event, newPage) => {
        dispatch({ type: 'SET_PAGE_EVENT', payload: newPage });
    };

    const handleChangeRowsPerPage = (event) => {
        dispatch({ type: 'SET_ROWS_PER_PAGE_EVENT', payload: parseInt(event.target.value, 10) });
        dispatch({ type: 'SET_PAGE_EVENT', payload: 0 });
    };

    const handleChangeDateEvent = (date) => {
        if (date === null) {
            dispatch({ type: 'SET_CLEAR_EVENT' });
        } else if (date) {
            let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            let year = date.getFullYear();
            let newDateEvent = day + '/' + month + '/' + year;
            dispatch({ type: 'SET_DATEEVENT_EVENT', payload: newDateEvent });
            dispatch({ type: 'SET_VALUEDATEEVENT_EVENT', payload: date });
        }
    };

    const getAllEvents = (title) => {
        getEvents(page + 1, rowsPerPage, title, dateEvent).then((resp) => setEvents(resp.data));
    };

    const debouncedSearch = React.useCallback(
        debounce((title) => {
            searchEvents(title, dateEvent).then((resp) => setEvents(resp.data));
        }, 300),
        []
    );

    React.useEffect(() => {
        if (searchTerm) {
            debouncedSearch(searchTerm);
        } else {
            getAllEvents();
        }
    }, [searchTerm]);

    const changeStatusActive = (event) => {
        const id = event.target.id;
        let checked = event.target.checked === true ? 1 : 0;
        const data = {
            active: checked
        };
        changeStatusEvent(id, data)
            .then((resp) => getAllEvents())
            .catch((resp) => getAllEvents());
    };

    const handleSubmit = () => {
        searchEvent();
        setOpenModalFilter(false);
    };

    const deleteEventById = () => {
        handleCloseModal();
        deleteEvent(idDestroyEvent)
            .then((resp) => {
                getAllEvents();
                setError('');
                setSuccess(resp.data.success);
                setIdDestroyEvent('');
                setTimeout(() => {
                    setSuccess('');
                }, 3000);
            })
            .catch((e) => {
                setSuccess('');
                setError(e.response.data.error);
                setTimeout(() => {
                    setError('');
                }, 4000);
            });
    };

    const getStatus = (event) => {
        if (event.active === 1) {
            return 'Postado';
        }

        if (event?.schedulingPost) {
            return 'Agendado';
        }

        return 'Desativado';
    };

    React.useEffect(() => {
        getAllEvents();
    }, [page, rowsPerPage]);

    React.useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === 'eventos');
        if (currentIndex > -1) {
            dispatch({ type: MENU_OPEN, id: 'eventos' });
        }
    }, []);

    return (
        <>
            <BasicModal
                open={openModal}
                title="Excluir Evento"
                handleClose={handleCloseModal}
                description="Tem certeza que deseja excluir o evento ?"
                onDelete={deleteEventById}
            />
            <ModalFilter
                open={openModalFilter}
                title="Filtros"
                handleClose={handleCloseModalFilter}
                content={
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={matchDownSM ? 0 : 2}>
                            <Grid item xs={12} sm={12} sx={{ marginTop: 3 }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                    <Stack spacing={3}>
                                        <DesktopDatePicker
                                            label="Data do evento"
                                            value={valueDateEvent}
                                            onChange={(e) => handleChangeDateEvent(e)}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" justifyContent="center" sx={{ mt: 3 }}>
                            <Grid item>
                                <Box sx={{ mt: 2, mr: 3 }}>
                                    <AnimateButton>
                                        <Button
                                            disableElevation
                                            fullWidth
                                            size="large"
                                            type="button"
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => [
                                                dispatch({ type: 'SET_CLEAR_EVENT' }),
                                                setOpenModalFilter(false),
                                                getAllEvents()
                                            ]}
                                        >
                                            Limpar Busca
                                        </Button>
                                    </AnimateButton>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box sx={{ mt: 2, mr: 3 }}>
                                    <AnimateButton>
                                        <Button fullWidth size="large" type="submit" color="primary" variant="contained">
                                            Buscar
                                        </Button>
                                    </AnimateButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                }
            />
            <TableContainer sx={{ mt: 2, height: '100%', padding: 3 }} component={Paper}>
                <Grid container spacing={matchDownSM ? 2 : 2}>
                    <Grid item xs={12} sm={6} md={8} sx={{ marginTop: 3 }}>
                        <h1
                            style={{
                                font: 'normal normal bold 35px/44px Roboto, sans-serif',
                                letterSpacing: '0px',
                                color: 'var(--unnamed-color-015641)',
                                Color: '#015641',
                                opacity: 1,
                                padding: 15,
                                marginLeft: '2%'
                            }}
                        >
                            <EventIcon /> EVENTOS
                        </h1>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} sx={{ marginTop: 8 }}>
                        <Box display="flex" justifyContent="right" alignItems="right" marginRight={2}>
                            <TextField
                                id="search"
                                label="Pesquisar"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <hr style={{ width: '95%', marginTop: 0 }}></hr>
                <h3
                    style={{
                        font: 'normal normal 300 18px/22px Roboto, sans-serif',
                        letterSpacing: '0px',
                        Color: '#00000',
                        opacity: 1,
                        padding: 15,
                        marginLeft: '2%'
                    }}
                >
                    Gerencie seus eventos
                </h3>
                {error || success ? (
                    <Snackbar open={true} autoHideDuration={6000}>
                        <Alert
                            severity={error ? 'error' : success ? 'success' : ''}
                            sx={{
                                width: '100%',
                                backgroundColor: error ? 'red' : success ? 'green' : 'orange',
                                color: '#FFF'
                            }}
                        >
                            {error ? error : success ? success : ''}
                        </Alert>
                    </Snackbar>
                ) : (
                    ''
                )}
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Postar</StyledTableCell>
                            <StyledTableCell style={{ width: 200 }}>Status</StyledTableCell>
                            <StyledTableCell>Título</StyledTableCell>
                            <StyledTableCell>Data Início</StyledTableCell>
                            <StyledTableCell>Data Término</StyledTableCell>
                            <StyledTableCell>Ações</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {events.data &&
                            events.data.map((row) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>
                                        <Toggle id={`${row.id}`} checked={row.active === 1 ? true : false} onChange={changeStatusActive} />
                                    </StyledTableCell>
                                    <StyledTableCell>{getStatus(row)}</StyledTableCell>
                                    <StyledTableCell>{row.title}</StyledTableCell>
                                    <StyledTableCell>{row.initialDate}</StyledTableCell>
                                    <StyledTableCell>{row.finalDate}</StyledTableCell>
                                    <Tooltip title="Visualizar">
                                        <IconButton onClick={() => navigate({ pathname: `/evento/${row.id}/view` })}>
                                            <ViewIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Editar">
                                        <IconButton onClick={() => navigate({ pathname: `/evento/${row.id}/edit` })}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Excluir">
                                        <IconButton onClick={() => handleOpenDestroy(row.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
                                colSpan={3}
                                count={events.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': 'Registros por Página'
                                    },
                                    native: true
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <SpeedDial
                direction="left"
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                FabProps={{
                    sx: {
                        bgcolor: '#015641',
                        '&:hover': {
                            bgcolor: '#0a8f53'
                        }
                    }
                }}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={(e) => (action.operation === 'filtros' ? [e.stopPropagation(), setOpenModalFilter(true)] : '')}
                    />
                ))}
            </SpeedDial>
        </>
    );
}
